import { cn } from '@/lib/utils';
import { TransactionTypeEnum } from '@/enums';
import type { IAmountDisplayProps } from '@/interfaces';

export const AmountDisplay = ({ amount, type }: IAmountDisplayProps) => {
	const isIncome = type === TransactionTypeEnum.INCOME;
	return (
		<span className={cn('font-bold tabular-nums block text-left', isIncome ? 'text-emerald-500' : 'text-red-500')}>
			{isIncome ? '+' : '-'}
			{(amount || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} €
		</span>
	);
};
